import * as Scrivito from "scrivito"

export const ProductDeliveryTimeUploadWidget = Scrivito.provideWidgetClass(
  "ProductDeliveryTimeUploadWidget",
  {
    attributes: {
      fileLabel: "string",
      inputLabel: "string"
    }
  }
)

export type ProductDeliveryTimeUploadWidgetObj = InstanceType<
  typeof ProductDeliveryTimeUploadWidget
>
